import { useNavigateWithOfflineMode } from '@hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Popup } from '../Popup';

const NoNetworkPopup = () => {
  const { isPopupVisible } = useNavigateWithOfflineMode();
  const { i18n } = useTranslation();

  return (
    <Popup
      isPopupVisible={isPopupVisible}
      text={i18n.t('MainPage.NoConnection')}
      variant="warning"
    />
  );
};

NoNetworkPopup.propTypes = {};

export default NoNetworkPopup;
